import { render, staticRenderFns } from "./FormBeneficio.vue?vue&type=template&id=e5185952&"
import script from "./FormBeneficio.vue?vue&type=script&lang=js&"
export * from "./FormBeneficio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports